import Vue from 'vue'
import Vuex from 'vuex'
import {Storage} from "@/services/Storage";
import axios from "axios";

Vue.use(Vuex)

export default {
    name: 'AuthModule',
    state: {
        pendingRequests : []
    },
    getters: {
        getPendingRequests:(state)=>state.pendingRequests
    },
    mutations: {
        setPendingRequests:(state , data)=>state.pendingRequests = data
    },
    actions: {
        getAllPendingRequests: async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `supervisor/${storeDB}/getAll`)
                .then(({data}) => context.commit(`setPendingRequests`,data))
        },
        approveRequest:async (context , id)=> {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            return axios.post(backOfficeTomcatApi+`supervisor/${storeDB}/approveRequest/${id}?user=${user.Username}`)
                .catch(err=>errorHandler.tomcatError(err))
        },
        cancelRequest:async (context , id)=> {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            return axios.post(backOfficeTomcatApi+`supervisor/${storeDB}/cancelRequest/${id}?user=${user.Username}`)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getRequestImage:async (context , id)=> {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi+`supervisor/${storeDB}/getImage/${id}`,{responseType:`blob`})
                .then(({data})=>URL.createObjectURL(data))
                .catch(err=>errorHandler.tomcatError(err))
        },
    },
}
